import { ProductRequestApprovalStatus } from "../enums/product-request-approval-status";
import { ProductRequest } from "../models/ProductRequest";

export function getAwaitingApprovalProductRequestItemCount(productRequest: ProductRequest): number {
    return productRequest.items.filter(item => item.approvalStatus === ProductRequestApprovalStatus.PENDING).length;
}